import CrudCustom from '../../../libs/custom/CrudCustom';

let ElemenTranskripService = new CrudCustom('/elemen-transkrips');
export default ElemenTranskripService;
